import React, { useEffect, useState, useMemo } from 'react';
import NavBar from '../../component/b2c/navBar/navBar';
import Sidebar from '../../component/b2c/sidebar/sidebar';
import { useMyContext } from '../../context/MyContext';
import '../../css/custom-scrollbar.css';
import { FaUser } from "react-icons/fa";
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { Button } from '@mui/material';
import { IoMdEye } from 'react-icons/io';
import { MdDelete } from 'react-icons/md';
import axios from 'axios';
import Swal from "sweetalert2";
import { Base_Url, userlist, deleteuser } from '../../config/config';
import { toast } from 'react-toastify';
import '../../../src/css/custom-scrollbar.css'
import { CiEdit } from "react-icons/ci";
import { AiOutlineDownload } from "react-icons/ai";
import { Search, Wallet, TrendingUp, AlertCircle } from 'lucide-react';
import CustomerDetailSideDrawer from './CustomerDetailSideDrawer';

const ViewAllCustomer = () => {
  const { isDarkMode, isToggleSidebar,setIsToggleSidebar } = useMyContext();
  const [customers, setCustomers] = useState([]);
  const [totalCustomer, setTotalCustomers] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [balanceFilter, setBalanceFilter] = useState('all'); // 'all' | 'positive' | 'negative' | 'zero'


  useEffect(() => {
    fetchCustomers();
  }, [currentPage, limit]);

  const handleViewClick = (customer) => {
    setSelectedCustomer(customer);
    setIsPopupOpen(true);
  };

  const handleClose = () => {
    setIsPopupOpen(false);
  };

  const handleDownloadCSV = (customer) => {
    const csvContent = `data:text/csv;charset=utf-8,${[
      ["ID", "Name", "Email", "Phone", "Company Name", "Company Type", "GST No", "Pancard No", "Aadharcard No"],
      [customer.id,
      customer.name,
      customer.email,
      customer.phone,
      customer.company_name,
      customer.company_type,
      customer.gst_number,
      customer.pancard_number,
      customer.aadhar_number
      ]
    ]
      .map((row) => row.join(","))
      .join("\n")}`;
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `customer_${customer.id}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Wallet balance: API provides `wallet_amount`
  const getCustomerBalance = (customer) => {
    const raw = customer?.wallet_amount ?? customer?.balance ?? customer?.wallet_balance ?? customer?.walletBalance ??
      customer?.totalamount ?? customer?.total_amount ?? customer?.wallet ?? customer?.txn_amount ?? customer?.closing_balance;
    if (raw === undefined || raw === null || raw === '') return null;
    const num = Number(raw);
    return isNaN(num) ? raw : num;
  };

  const handleDownloadAllCustomers = () => {
    const csvContent = [
      ["ID", "Name", "Email", "Phone", "Balance", "Company Name", "Company Type", "GST No", "Pancard No", "Aadharcard No"],
      ...customers.map(customer => [
        customer.id,
        customer.name,
        customer.email,
        customer.phone,
        getCustomerBalance(customer) ?? '0',
        customer.company_name,
        customer.company_type,
        customer.gst_number,
        customer.pancard_number,
        customer.aadhar_number
      ])
    ]
      .map(row => row.join(","))
      .join("\n");

    if (customers.length === 0) {
      toast.error("No customers available to download");
      return;
    }

    const encodedUri = encodeURI(`data:text/csv;charset=utf-8,${csvContent}`);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "all_customers.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fetchCustomers = async () => {
    const url = `${Base_Url}admin/${userlist}?page=${currentPage}&limit=${limit}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        const filteredCustomers = data.data.filter(customer => customer.role !== 'admin');
        const adminCount = data.data.filter(customer => customer.role === 'admin').length;
        const adjustedTotal = data.pagination.totalItems - adminCount;

        setCustomers(filteredCustomers);
        setTotalCustomers(adjustedTotal || 0);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleBalanceFilterChange = async (filterType) => {
    setBalanceFilter(filterType);
    if (filterType !== 'all' && customers.length < totalCustomer) {
      try {
        const url = `${Base_Url}admin/${userlist}?page=1&limit=${totalCustomer || 1000}`;
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            token: token,
            cus_id: cus_id,
            'Content-Type': 'application/json'
          }
        });
        const data = await response.json();
        if (data.status === "SUCCESS") {
          const filteredCustomers = data.data.filter(customer => customer.role !== 'admin');
          const adminCount = data.data.filter(customer => customer.role === 'admin').length;
          const adjustedTotal = data.pagination?.totalItems ? data.pagination.totalItems - adminCount : filteredCustomers.length;
          setCustomers(filteredCustomers);
          setTotalCustomers(adjustedTotal || filteredCustomers.length);
          setLimit(adjustedTotal || filteredCustomers.length);
          setCurrentPage(1);
        }
      } catch (err) {
        console.error("Error fetching all customers for balance filter:", err);
      }
    }
  };

  const balanceCounts = useMemo(() => {
    let pos = 0;
    let neg = 0;
    let zero = 0;
    customers.forEach((c) => {
      const b = getCustomerBalance(c);
      if (typeof b === 'number') {
        if (b > 0) pos++;
        else if (b < 0) neg++;
        else if (b === 0) zero++;
      }
    });
    return { positive: pos, negative: neg, zero: zero };
  }, [customers]);

  const getFilteredCustomers = () => {
    let list = customers;

    // 1. Balance Filter
    if (balanceFilter === 'positive') {
      list = list.filter((c) => {
        const b = getCustomerBalance(c);
        return typeof b === 'number' && b > 0;
      });
    } else if (balanceFilter === 'negative') {
      list = list.filter((c) => {
        const b = getCustomerBalance(c);
        return typeof b === 'number' && b < 0;
      });
    } else if (balanceFilter === 'zero') {
      list = list.filter((c) => {
        const b = getCustomerBalance(c);
        return typeof b === 'number' && b === 0;
      });
    }

    // 2. Search Term Filter
    if (!searchTerm.trim()) {
      return list;
    }

    const term = searchTerm.toLowerCase();
    return list.filter(customer => {
      return (
        (customer.id?.toString().toLowerCase().includes(term)) ||
        (customer.name?.toLowerCase().includes(term)) ||
        (customer.phone?.toString().toLowerCase().includes(term)) ||
        (customer.email?.toLowerCase().includes(term)) ||
        (customer.company_name?.toLowerCase().includes(term))
      );
    });
  };

  const displayCustomers = getFilteredCustomers();

  const handleLimitChange = (e) => {
    setLimit(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const handlePaginationChange = (e, value) => {
    setCurrentPage(value);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows([...Array(customers.length).keys()]);
    } else {
      setSelectedRows([]);
    }
    setSelectAll(e.target.checked);
  };

  const handleRowSelect = (index) => {
    setSelectedRows((prev) => {
      const isSelected = prev.includes(index);
      if (isSelected) {
        return prev.filter(i => i !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  // 🔥 UI-only toggle (no backend API endpoint exists yet)
  const handleStatusToggle = (customerId) => {
    setCustomers((prev) =>
      prev.map((c) => {
        if (c.id === customerId) {
          const currentlyActive = checkIsActive(c);
          const nextVal = currentlyActive ? 0 : 1;
          return { ...c, status: nextVal, account_status: nextVal ? "active" : "inactive" };
        }
        return c;
      })
    );
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this deletion!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#000000',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const urldelete = Base_Url + deleteuser;
        try {
          const token = localStorage.getItem('token');
          const cusid = localStorage.getItem('cus_id');
          const data = {
            retailer_id: id
          };
          const response = await axios.post(urldelete, data, {
            headers: {
              token,
              cus_id: cusid,
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
          });

          if (response.data.status === "SUCCESS") {
            fetchCustomers();
            Swal.fire(
              'Deleted!',
              response.data.message || 'Reatiler has been deleted successfully.',
              'success'
            );
          } else {
            Swal.fire(
              'Error!',
              'Unexpected response format: ' + response.data.message,
              'error'
            );
          }
        } catch (error) {
          Swal.fire(
            'Error!',
            'Error deleting Retailer: ' + error.message,
            'error'
          );
        }
      }
    });
  };

  const glass =
    "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
    "border border-white/60 dark:border-white/10 " +
    "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";

  const checkIsActive = (customer) => {
    const s = String(customer?.status ?? '').trim().toLowerCase();
    const acc = String(customer?.account_status ?? '').trim().toLowerCase();
    return s === '1' || s === 'active' || acc === '1' || acc === 'active';
  };

  // Mobile card view for each customer
  const renderMobileCard = (customer, index) => {
    const isActive = checkIsActive(customer);
    const balance = getCustomerBalance(customer);

    return (
      <div
        key={customer.id || index}
        className={`rounded-xl border overflow-hidden transition-all duration-200 ${
          isDarkMode
            ? 'bg-gradient-to-br from-[#0f172a] via-[#0b1220] to-[#0f172a] border-indigo-500/25 shadow-[0_4px_20px_rgba(79,70,229,0.15)]'
            : 'bg-white border-gray-200 shadow-sm'
        }`}
      >
        {/* Top strip: Name + ID (Clickable) */}
        <div
          onClick={() => handleViewClick(customer)}
          className={`flex items-center justify-between gap-3 px-3 py-2.5 border-b cursor-pointer group/cardhead transition-colors ${
            isDarkMode
              ? 'bg-gradient-to-r from-indigo-600/20 via-purple-600/15 to-indigo-600/20 hover:from-indigo-600/30 border-indigo-500/25'
              : 'bg-gray-50 hover:bg-violet-50/70 border-gray-200'
          }`}
          title="Click to view customer details"
        >
          <div className="min-w-0 flex-1">
            <p className={`text-[9px] uppercase tracking-wider mb-0.5 font-semibold ${
              isDarkMode ? 'text-indigo-300/80' : 'text-gray-400'
            }`}>
              Name
            </p>
            <p className={`text-[12px] font-semibold truncate group-hover/cardhead:text-indigo-600 dark:group-hover/cardhead:text-indigo-300 transition-colors ${
              isDarkMode ? 'text-white' : 'text-gray-900'
            }`}>
              {customer.name || '—'}
            </p>
          </div>
          <div className="text-right shrink-0">
            <p className={`text-[9px] uppercase tracking-wider mb-0.5 font-semibold ${
              isDarkMode ? 'text-indigo-300/80' : 'text-gray-400'
            }`}>
              ID
            </p>
            <p className={`text-[11px] font-mono font-semibold ${
              isDarkMode ? 'text-indigo-200' : 'text-gray-700'
            }`}>
              {customer.id}
            </p>
          </div>
        </div>

        {/* Body: detail rows */}
        <div className={`px-3 py-2 divide-y ${
          isDarkMode ? 'divide-indigo-500/15' : 'divide-gray-100'
        }`}>
          <div className="flex items-center justify-between py-2 gap-3">
            <span className={`text-[10px] font-medium uppercase tracking-wider shrink-0 ${
              isDarkMode ? 'text-indigo-300/70' : 'text-gray-500'
            }`}>
              Email
            </span>
            <span className={`text-[11px] font-medium text-right truncate ${
              isDarkMode ? 'text-slate-300' : 'text-gray-800'
            }`}>
              {customer.email || '—'}
            </span>
          </div>

          <div className="flex items-center justify-between py-2 gap-3">
            <span className={`text-[10px] font-medium uppercase tracking-wider shrink-0 ${
              isDarkMode ? 'text-indigo-300/70' : 'text-gray-500'
            }`}>
              Phone
            </span>
            <span className={`text-[11px] font-mono ${
              isDarkMode ? 'text-slate-300' : 'text-gray-800'
            }`}>
              {customer.phone || '—'}
            </span>
          </div>

          <div className="flex items-center justify-between py-2 gap-3">
            <span className={`text-[10px] font-medium uppercase tracking-wider shrink-0 ${
              isDarkMode ? 'text-indigo-300/70' : 'text-gray-500'
            }`}>
              Balance
            </span>
            <span className={`text-[11px] font-bold px-2.5 py-0.5 rounded-md border ${
              balance === null
                ? (isDarkMode ? 'text-gray-500 border-transparent' : 'text-gray-400 border-transparent')
                : typeof balance === 'number' && balance < 0
                  ? (isDarkMode ? 'bg-rose-500/15 text-rose-300 border-rose-500/30 font-extrabold' : 'bg-rose-50 text-rose-700 border-rose-200 font-extrabold')
                  : typeof balance === 'number' && balance > 0
                    ? (isDarkMode ? 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30' : 'bg-emerald-50 text-emerald-700 border-emerald-200')
                    : (isDarkMode ? 'bg-slate-800 text-slate-400 border-slate-700' : 'bg-slate-100 text-slate-600 border-slate-200')
            }`}>
              {balance === null ? 'N/A' : `₹ ${typeof balance === 'number' ? balance.toLocaleString('en-IN') : balance}`}
            </span>
          </div>

          <div className="flex items-center justify-between py-2 gap-3">
            <span className={`text-[10px] font-medium uppercase tracking-wider shrink-0 ${
              isDarkMode ? 'text-indigo-300/70' : 'text-gray-500'
            }`}>
              Status
            </span>
            <div className="flex items-center gap-1.5">
              <button
                onClick={() => handleStatusToggle(customer.id)}
                title={isActive ? "Active (click to deactivate)" : "Inactive (click to activate)"}
                className={`relative inline-flex h-4 w-8 items-center rounded-full transition-all duration-300 ${
                  isActive
                    ? (isDarkMode
                        ? 'bg-gradient-to-r from-blue-500 to-blue-600 shadow-[0_0_10px_rgba(59,130,246,0.5)]'
                        : 'bg-blue-500')
                    : (isDarkMode
                        ? 'bg-gray-700'
                        : 'bg-gray-300')
                }`}
              >
                <span
                  className={`inline-block h-3 w-3 transform rounded-full bg-white shadow transition-transform duration-200 ${
                    isActive ? "translate-x-4" : "translate-x-0.5"
                  }`}
                />
              </button>
              <span className={`text-[9px] font-semibold ${
                isActive
                  ? (isDarkMode ? 'text-blue-400' : 'text-blue-600')
                  : (isDarkMode ? 'text-gray-500' : 'text-gray-400')
              }`}>
                {isActive ? "Active" : "Inactive"}
              </span>
            </div>
          </div>
        </div>

        {/* Action buttons */}
        <div className={`flex items-center justify-end gap-2 px-3 py-2 border-t ${
          isDarkMode ? 'border-indigo-500/15 bg-indigo-500/5' : 'border-gray-100 bg-gray-50'
        }`}>
          <button
            onClick={() => handleViewClick(customer)}
            className={`p-1.5 rounded-lg border transition-all duration-200 ${
              isDarkMode
                ? 'border-indigo-500/40 text-indigo-300 hover:bg-indigo-500/10 hover:shadow-[0_0_10px_rgba(99,102,241,0.4)]'
                : 'border-gray-300 text-gray-600 hover:bg-gray-100'
            }`}
            title="View"
          >
            <IoMdEye size={12} />
          </button>
          <button
            onClick={() => handleDelete(customer.id)}
            className={`p-1.5 rounded-lg border transition-all duration-200 ${
              isDarkMode
                ? 'border-rose-500/40 text-rose-400 hover:bg-rose-500/10 hover:shadow-[0_0_10px_rgba(244,63,94,0.4)]'
                : 'border-gray-300 text-gray-600 hover:bg-gray-100'
            }`}
            title="Delete"
          >
            <MdDelete size={12} />
          </button>
          <button
            onClick={() => handleDownloadCSV(customer)}
            className={`p-1.5 rounded-lg border transition-all duration-200 ${
              isDarkMode
                ? 'border-blue-500/40 text-blue-400 hover:bg-blue-500/10 hover:shadow-[0_0_10px_rgba(59,130,246,0.4)]'
                : 'border-gray-300 text-gray-600 hover:bg-gray-100'
            }`}
            title="Download"
          >
            <AiOutlineDownload size={12} />
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className={`h-screen flex flex-col overflow-hidden transition-colors duration-300 ${isDarkMode ? 'dark bg-[#0B1120]' : 'bg-gray-50'}`}>
      {/* Premium ambient glows */}
      {isDarkMode ? (
        <>
          <div className="pointer-events-none absolute -top-40 -left-32 h-[500px] w-[500px] rounded-full bg-indigo-600/15 blur-[120px]" />
          <div className="pointer-events-none absolute top-1/2 -right-40 h-[400px] w-[400px] rounded-full bg-blue-600/10 blur-[100px]" />
        </>
      ) : (
        <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 blur-3xl" />
      )}

      <NavBar />
      <div className="flex flex-1 overflow-hidden relative z-10">
           {isToggleSidebar && (
                        <div
                            className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm md:hidden"
                            onClick={() => setIsToggleSidebar(false)}
                        />
                    )}

                    <div
                        className={`
                     fixed inset-y-0 left-0 z-50 w-64
                     ${isToggleSidebar ? "translate-x-0" : "-translate-x-full"}
                     md:static md:inset-auto md:z-auto md:translate-x-0
                     ${isToggleSidebar ? "md:w-64" : "md:w-[72px]"}
                     m-3
                     rounded-3xl
                 
                     overflow-hidden
                     transition-all
                     duration-300
                     ease-in-out
                   `}
                    >
                        <Sidebar />
                    </div>

        <div className={`flex-1 flex flex-col overflow-hidden p-2.5 sm:p-3 transition-colors duration-300 ${isDarkMode ? 'bg-[#0B1120]' : 'bg-gray-100'}`}>
          <div className={`flex flex-col flex-1 overflow-hidden rounded-2xl border p-2.5 sm:p-3 md:p-4 transition-colors duration-300 ${
            isDarkMode 
              ? 'bg-gradient-to-br from-[#111827] to-[#0F172A] border-gray-800 shadow-[0_0_30px_rgba(0,0,0,0.4)]' 
              : 'bg-white border-gray-200 shadow-sm'
          }`}>

            {/* Premium Header */}
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 shrink-0">
              <div className="flex items-center gap-2 flex-wrap">
                <div className={`p-2 rounded-lg border transition-all duration-300 flex-shrink-0 ${
                  isDarkMode 
                    ? 'bg-gradient-to-br from-indigo-500/20 to-purple-500/10 border-indigo-500/30 shadow-[0_0_15px_rgba(99,102,241,0.2)]' 
                    : 'border-gray-300'
                }`}>
                  <FaUser size={12} className={isDarkMode ? 'text-indigo-400' : 'text-blue-600'} />
                </div>
                <span className={`text-[11px] font-bold uppercase tracking-[0.15em] ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-700'
                }`}>
                  All Customers
                </span>
                <span className={`text-[11px] font-bold px-2 py-0.5 rounded-full transition-colors duration-300 ${
                  isDarkMode 
                    ? 'bg-indigo-500/15 text-indigo-300 border border-indigo-500/30' 
                    : 'bg-blue-100 text-blue-800'
                }`}>
                  {totalCustomer}
                </span>
              </div>
              {selectAll && (
                <button
                  onClick={handleDownloadAllCustomers}
                  className={`text-[10px] font-semibold px-3 py-1.5 rounded-lg flex items-center gap-1.5 transition-all ${
                    isDarkMode
                      ? 'bg-gradient-to-r from-blue-600 to-blue-600 text-white hover:shadow-[0_0_20px_rgba(59,130,246,0.5)]'
                      : 'bg-blue-800 text-white hover:opacity-80'
                  }`}
                >
                  <AiOutlineDownload size={11} />
                  Download All
                </button>
              )}
            </div>

            {/* Search & Balance Filters Toolbar */}
            <div className="flex flex-col md:flex-row items-stretch md:items-center justify-between gap-2.5 mt-3 shrink-0">
              {/* Search Input */}
              <div className="relative flex-1">
                <input
                  type="text"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  placeholder="Search by Name / ID / Phone / Email..."
                  className={`w-full pl-8 pr-3 py-2 text-[10.5px] rounded-xl border focus:outline-none transition-all duration-300 ${
                    isDarkMode
                      ? 'border-white/10 bg-white/[0.03] text-white placeholder-gray-500 focus:border-indigo-500/60 focus:bg-white/[0.06] focus:ring-2 focus:ring-indigo-500/20'
                      : 'border-gray-300 bg-white text-gray-800 focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500'
                  }`}
                />
                <Search className={`absolute left-2.5 top-1/2 transform -translate-y-1/2 w-3.5 h-3.5 ${
                  isDarkMode ? 'text-indigo-400' : 'text-gray-400'
                }`} />
              </div>

              {/* Balance Filter Pills */}
              <div className="flex items-center gap-1 p-1 rounded-xl bg-slate-100 dark:bg-slate-800/80 border border-slate-200 dark:border-slate-700 shrink-0 overflow-x-auto no-scrollbar">
                <div className="flex items-center gap-1 text-[10px] font-bold text-slate-400 dark:text-slate-500 px-1.5 uppercase tracking-wider">
                  <Wallet size={12} className="text-violet-500" />
                  <span className="hidden lg:inline">Balance:</span>
                </div>

                {/* All */}
                <button
                  type="button"
                  onClick={() => handleBalanceFilterChange('all')}
                  className={`px-2.5 py-1 rounded-lg text-[10.5px] font-bold transition-all whitespace-nowrap ${
                    balanceFilter === 'all'
                      ? (isDarkMode ? 'bg-indigo-600 text-white shadow-xs' : 'bg-white text-slate-900 shadow-xs border border-slate-200/80')
                      : 'text-slate-500 hover:text-slate-800 dark:hover:text-white'
                  }`}
                >
                  All ({customers.length})
                </button>

                {/* Positive Balance */}
                <button
                  type="button"
                  onClick={() => handleBalanceFilterChange('positive')}
                  className={`px-2.5 py-1 rounded-lg text-[10.5px] font-bold transition-all flex items-center gap-1 whitespace-nowrap ${
                    balanceFilter === 'positive'
                      ? 'bg-emerald-600 text-white shadow-xs shadow-emerald-500/20'
                      : 'text-emerald-600 dark:text-emerald-400 hover:bg-emerald-50 dark:hover:bg-emerald-950/30'
                  }`}
                  title="Filter customers with positive wallet balance (> ₹0)"
                >
                  <TrendingUp size={11} />
                  <span>Positive ({balanceCounts.positive})</span>
                </button>

                {/* Negative Balance */}
                <button
                  type="button"
                  onClick={() => handleBalanceFilterChange('negative')}
                  className={`px-2.5 py-1 rounded-lg text-[10.5px] font-bold transition-all flex items-center gap-1 whitespace-nowrap ${
                    balanceFilter === 'negative'
                      ? 'bg-rose-600 text-white shadow-xs shadow-rose-500/20'
                      : 'text-rose-600 dark:text-rose-400 hover:bg-rose-50 dark:hover:bg-rose-950/30'
                  }`}
                  title="Filter customers with negative wallet balance (< ₹0)"
                >
                  <AlertCircle size={11} />
                  <span>Negative ({balanceCounts.negative})</span>
                </button>

                {/* Zero Balance */}
                <button
                  type="button"
                  onClick={() => handleBalanceFilterChange('zero')}
                  className={`px-2.5 py-1 rounded-lg text-[10.5px] font-bold transition-all whitespace-nowrap ${
                    balanceFilter === 'zero'
                      ? (isDarkMode ? 'bg-slate-700 text-white shadow-xs' : 'bg-slate-800 text-white shadow-xs')
                      : 'text-slate-500 hover:text-slate-800 dark:hover:text-white'
                  }`}
                  title="Filter customers with zero wallet balance (₹0)"
                >
                  Zero ({balanceCounts.zero})
                </button>
              </div>
            </div>

            {/* Premium Table */}
            <div className={`flex-1 overflow-y-auto overflow-x-auto mt-3 rounded-xl border custom-scrollbar transition-colors duration-300 ${
              isDarkMode 
                ? 'border-gray-800 shadow-[0_0_20px_rgba(0,0,0,0.3)]' 
                : 'border-violet-200/70 bg-gradient-to-br from-violet-50/70 via-white to-sky-50/80 shadow-[0_8px_30px_rgba(124,58,237,0.08)]'
            }`}>
              {/* Mobile/Tablet Card View (hidden on lg+) */}
              <div className="lg:hidden p-2 space-y-3">
                {displayCustomers.length === 0 ? (
                  <div className={`text-center py-6 text-[10px] ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                    No customers found
                  </div>
                ) : (
                  displayCustomers.map((customer, index) => renderMobileCard(customer, index))
                )}
              </div>

              {/* Desktop Table View (hidden below lg) */}
              <table className="hidden lg:table min-w-full w-full table-fixed border-collapse">
                <colgroup>
                  <col style={{ width: '4%' }} />
                  <col style={{ width: '7%' }} />
                  <col style={{ width: '20%' }} />
                  <col style={{ width: '23%' }} />
                  <col style={{ width: '12%' }} />
                  <col style={{ width: '13%' }} />
                  <col style={{ width: '13%' }} />
                  <col style={{ width: '10%' }} />
                </colgroup>
                <thead className={`text-[9px] uppercase tracking-[0.08em] sticky top-0 z-10 transition-colors duration-300 ${
                  isDarkMode
                    ? 'bg-[#1b2433] text-gray-300 border-b border-gray-700'
                    : 'bg-gradient-to-r from-violet-100/80 via-blue-50 to-sky-100/80 text-violet-700 border-b border-violet-200/70 backdrop-blur'
                }`}>
                  <tr>
                    <th className="px-3 py-3 text-center">
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                        className={`cursor-pointer rounded ${isDarkMode ? 'accent-indigo-500' : 'accent-blue-600'}`}
                      />
                    </th>
                    <th className="px-3 py-3 text-left font-bold">ID</th>
                    <th className="px-3 py-3 text-left font-bold">Customer</th>
                    <th className="px-3 py-3 text-left font-bold">Email</th>
                    <th className="px-3 py-3 text-left font-bold">Phone</th>
                    <th className="px-3 py-3 text-center font-bold">Balance</th>
                    <th className="px-3 py-3 text-center font-bold">Status</th>
                    <th className="px-3 py-3 text-center font-bold">Actions</th>
                  </tr>
                </thead>
                <tbody className={`divide-y transition-colors duration-300 ${
                  isDarkMode ? 'divide-gray-800' : 'divide-violet-100/70'
                }`}>
                  {displayCustomers.length === 0 ? (
                    <tr>
                      <td colSpan="8" className={`p-10 text-center text-[11px] ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                        No customers found
                      </td>
                    </tr>
                  ) : (
                    displayCustomers.map((customer, index) => {
                      const isActive = checkIsActive(customer);
                      const balance = getCustomerBalance(customer);
                      const initials = (customer.name || '?')
                        .split(' ').filter(Boolean).slice(0, 2).map((w) => w[0]).join('').toUpperCase();
                      const iconBtn = (tone) => `inline-flex items-center justify-center w-7 h-7 rounded-lg transition-all duration-200 ${
                        isDarkMode
                          ? `bg-white/5 hover:bg-white/10 ${tone.dark}`
                          : `bg-slate-50 border border-slate-200 ${tone.light}`
                      }`;
                      const tones = {
                        view: { dark: 'text-indigo-300', light: 'text-slate-500 hover:text-indigo-600 hover:bg-indigo-50 hover:border-indigo-200' },
                        del: { dark: 'text-rose-400', light: 'text-slate-500 hover:text-rose-600 hover:bg-rose-50 hover:border-rose-200' },
                        dl: { dark: 'text-blue-400', light: 'text-slate-500 hover:text-blue-600 hover:bg-blue-50 hover:border-blue-200' },
                      };
                      return (
                        <tr
                          key={customer.id}
                          className={`group transition-colors duration-150 ${
                            isDarkMode
                              ? index % 2 === 0 ? 'bg-[#111827] hover:bg-[#1F2937]' : 'bg-[#0F172A] hover:bg-[#1F2937]'
                              : 'bg-white/60 hover:bg-violet-50/80 hover:shadow-[inset_3px_0_0_#8b5cf6]'
                          }`}
                        >
                          <td className="px-3 py-3 text-center">
                            <input
                              type="checkbox"
                              checked={selectedRows.includes(index)}
                              onChange={() => handleRowSelect(index)}
                              className={`cursor-pointer rounded ${isDarkMode ? 'accent-indigo-500' : 'accent-blue-600'}`}
                            />
                          </td>
                          <td className="px-3 py-3">
                            <span className={`inline-block px-1.5 py-0.5 rounded-md text-[10px] font-mono font-semibold ${
                              isDarkMode ? 'bg-indigo-500/10 text-indigo-300' : 'bg-slate-100 text-slate-600'
                            }`}>#{customer.id}</span>
                          </td>
                          <td className="px-3 py-3">
                            <div
                              onClick={() => handleViewClick(customer)}
                              className="flex items-center gap-2.5 min-w-0 cursor-pointer group/customer select-none"
                              title={`View ${customer.name}'s profile, orders & wallet`}
                            >
                              <div className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center text-[10px] font-bold group-hover/customer:scale-110 group-hover/customer:ring-2 group-hover/customer:ring-indigo-400 transition-all ${
                                isDarkMode
                                  ? 'bg-indigo-500/20 text-indigo-200'
                                  : 'bg-gradient-to-br from-violet-200 to-sky-200 text-violet-800 ring-2 ring-white shadow-sm'
                              }`}>{initials}</div>
                              <span className={`text-[11px] font-semibold truncate group-hover/customer:text-indigo-600 dark:group-hover/customer:text-indigo-300 group-hover/customer:underline underline-offset-2 transition-colors ${
                                isDarkMode ? 'text-gray-100' : 'text-slate-800'
                              }`} title={customer.name}>
                                {customer.name}
                              </span>
                            </div>
                          </td>
                          <td className={`px-3 py-3 text-[10.5px] truncate ${isDarkMode ? 'text-gray-400' : 'text-slate-500'}`} title={customer.email}>{customer.email}</td>
                          <td className={`px-3 py-3 text-[10.5px] font-mono truncate ${isDarkMode ? 'text-gray-400' : 'text-slate-600'}`}>{customer.phone}</td>
                          <td className="px-3 py-3 text-center">
                            {balance === null ? (
                              <span className={`text-[10px] font-medium ${isDarkMode ? 'text-gray-600' : 'text-slate-300'}`}>N/A</span>
                            ) : (
                              <span className={`inline-block px-2.5 py-0.5 rounded-md text-[10.5px] font-bold tabular-nums border transition-all ${
                                typeof balance === 'number' && balance < 0
                                  ? (isDarkMode ? 'bg-rose-500/15 text-rose-300 border-rose-500/30 font-extrabold' : 'bg-rose-50 text-rose-700 border-rose-200 font-extrabold')
                                  : typeof balance === 'number' && balance > 0
                                    ? (isDarkMode ? 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30' : 'bg-emerald-50 text-emerald-700 border-emerald-200')
                                    : (isDarkMode ? 'bg-slate-800 text-slate-400 border-slate-700' : 'bg-slate-100 text-slate-600 border-slate-200')
                              }`}>
                                ₹ {typeof balance === 'number' ? balance.toLocaleString('en-IN') : balance}
                              </span>
                            )}
                          </td>
                          {/* Status */}
                          <td className="px-3 py-3 text-center">
                            <button
                              onClick={() => handleStatusToggle(customer.id)}
                              title={isActive ? "Active (click to deactivate)" : "Inactive (click to activate)"}
                              className={`inline-flex items-center gap-1.5 pl-1.5 pr-2.5 py-1 rounded-full border text-[9.5px] font-semibold transition-all duration-200 ${
                                isActive
                                  ? (isDarkMode ? 'bg-blue-500/10 border-blue-500/30 text-blue-300' : 'bg-sky-50 border-sky-200 text-sky-700')
                                  : (isDarkMode ? 'bg-gray-700/40 border-gray-600 text-gray-400' : 'bg-slate-50 border-slate-200 text-slate-400')
                              }`}
                            >
                              <span className={`relative inline-flex h-3.5 w-6 items-center rounded-full transition-colors duration-200 ${
                                isActive ? 'bg-gradient-to-r from-violet-500 to-blue-500' : (isDarkMode ? 'bg-gray-600' : 'bg-slate-300')
                              }`}>
                                <span className={`inline-block h-2.5 w-2.5 transform rounded-full bg-white shadow transition-transform duration-200 ${
                                  isActive ? 'translate-x-[11px]' : 'translate-x-0.5'
                                }`} />
                              </span>
                              {isActive ? "Active" : "Inactive"}
                            </button>
                          </td>
                          <td className="px-3 py-3">
                            <div className="flex items-center justify-center gap-1.5">
                              <button onClick={() => handleViewClick(customer)} className={iconBtn(tones.view)} title="View">
                                <IoMdEye size={13} />
                              </button>
                              <button onClick={() => handleDelete(customer.id)} className={iconBtn(tones.del)} title="Delete">
                                <MdDelete size={13} />
                              </button>
                              <button onClick={() => handleDownloadCSV(customer)} className={iconBtn(tones.dl)} title="Download">
                                <AiOutlineDownload size={13} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* Premium Footer */}
            <div className={`mt-3 flex flex-col sm:flex-row justify-between items-center gap-2 shrink-0 pt-3 border-t transition-colors duration-300 ${
              isDarkMode ? 'border-gray-800' : 'border-gray-100'
            }`}>
              <span className={`text-[9px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                Total: <span className={`font-bold ${isDarkMode ? 'text-indigo-300' : 'text-gray-800'}`}>{totalCustomer}</span> customers
              </span>
              <div className="flex items-center gap-2">
                <select
                  id="limit"
                  value={limit}
                  onChange={handleLimitChange}
                  className={`border rounded-lg p-1 text-[9px] focus:outline-none transition-colors duration-300 ${
                    isDarkMode
                      ? 'border-gray-700 bg-[#1F2937] text-gray-200 focus:ring-1 focus:ring-indigo-500'
                      : 'border-gray-300 bg-white text-gray-800 focus:ring-1 focus:ring-gray-500'
                  }`}
                >
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                  <option value={25}>25</option>
                  <option value={30}>30</option>
                  <option value={totalCustomer}>All</option>
                </select>
                <Pagination
                  count={balanceFilter === 'all' ? Math.max(1, Math.ceil(totalCustomer / limit)) : Math.max(1, Math.ceil(displayCustomers.length / limit))}
                  page={currentPage}
                  onChange={handlePaginationChange}
                  variant="outlined"
                  shape="rounded"
                  size="small"
                  sx={{
                    '& .MuiPaginationItem-root': {
                      fontSize: '10px',
                      borderColor: isDarkMode ? '#374151' : '#d1d5db',
                      color: isDarkMode ? '#E5E7EB' : '#374151',
                      '&.Mui-selected': {
                        backgroundColor: isDarkMode ? 'rgba(99,102,241,0.2)' : '#000',
                        color: isDarkMode ? '#a5b4fc' : '#fff',
                        borderColor: isDarkMode ? '#6366f1' : '#000',
                        boxShadow: isDarkMode ? '0 0 10px rgba(99,102,241,0.4)' : 'none',
                      },
                      '&:hover': {
                        backgroundColor: isDarkMode ? 'rgba(99,102,241,0.1)' : '#F3F4F6',
                      }
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <CustomerDetailSideDrawer
          isOpen={isPopupOpen}
          onClose={handleClose}
          customer={selectedCustomer}
          isDarkMode={isDarkMode}
        />
      </div>
    </div>
  );
};

export default ViewAllCustomer;